import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgLetDirective } from './directives/ng-let.directive';
import { PanelTriggerDirective } from './directives/panel-trigger.directive';
import { RouterDirective } from './directives/router.directive';
import { TypedTemplateDirective } from './directives/typed-template.directive';
import { OrderByKeyPipe } from './pipes/array.pipes';
import { CastPipe } from './pipes/cast.pipe';
import { ContentOrDashPipe } from './pipes/content-or-dash.pipe';
import { GetIndexPipe } from './pipes/get-index.pipe';
import { MethodPipe } from './pipes/method.pipe';

@NgModule({
    declarations: [
        NgLetDirective,
        MethodPipe,
        CastPipe,
        TypedTemplateDirective,
        OrderByKeyPipe,
        RouterDirective,
        PanelTriggerDirective,
        GetIndexPipe,
    ],
    imports: [CommonModule, LayoutModule, ContentOrDashPipe],
    exports: [
        NgLetDirective,
        MethodPipe,
        CastPipe,
        TypedTemplateDirective,
        OrderByKeyPipe,
        RouterDirective,
        PanelTriggerDirective,
        GetIndexPipe,
        ContentOrDashPipe
    ]
})
export class BaseModule {}
